import Sidebar from '../pages/meeting-view/components/Sidebar/Sidebar'
import styled from 'styled-components'
import { useZoomContext } from '../context/ZoomContext'
import { LoadingBolt } from '../components/LoadingBolt'
import { useEffect, useState } from 'react'
import Controls from '../pages/meeting-view/components/VideoFooter/Controls'
import { useShare } from '../context/ShareContext'
import ControlsLeft from '../pages/meeting-view/components/VideoFooter/ControlsLeft'
import ControlsRight from '../pages/meeting-view/components/VideoFooter/ControlsRight'
import { AppToaster } from '../components/AppToaster'
type LayoutProps = {
    children: React.ReactNode
    token?: string
    isLoading?: boolean
}

const MeetingLayout = ({ children, isLoading = false }: LayoutProps) => {
    const { sidebarMode } = useZoomContext()
    const [isTransitioning, setIsTransitioning] = useState(false)
    const [wasSidebarVisible, setWasSidebarVisible] = useState(false)
    const { selfShareRef } = useShare()

    useEffect(() => {
        const isSidebarVisible = sidebarMode !== null

        if (isSidebarVisible !== wasSidebarVisible) {
            setIsTransitioning(true)
            setTimeout(() => {
                setIsTransitioning(false)
            }, 600)
            setWasSidebarVisible(isSidebarVisible)
        }
    }, [sidebarMode, wasSidebarVisible])

    if (isLoading) return <LoadingBolt />
    return (
        <StyledMeetingLayout>
            <AppToaster />
            <div className="container">
                <div className={`col-left ${sidebarMode ? 'with-sidebar' : ''}`}>
                    <div className="content-display">{children}</div>
                    {isTransitioning && (
                        <div className="transition-overlay">
                            <div className="loader"></div>
                        </div>
                    )}
                </div>
                {sidebarMode && (
                    <div className="col-right">
                        <Sidebar />
                    </div>
                )}
            </div>
            <div className="footer">
                <ControlsLeft />
                <Controls selfShareRef={selfShareRef} />
                <ControlsRight />
            </div>
        </StyledMeetingLayout>
    )
}

export default MeetingLayout

const StyledMeetingLayout = styled.div`
    // background-color: ${props => props.theme.color.offWhite};
    // background-color: red;
    // padding:5px;
    height: 100vh;
    display: flex;
    flex-direction: column;

    .container {
        background-color: rgb(20, 20, 20);
        margin: 0 auto;
        box-sizing: border-box;
        display: flex;
        flex: 1;
        overflow: hidden;
        width: 100%;
        // padding:5px;
        // background-color: green;
        @media only screen and (max-width: 768px) {
            flex: none;
            height: calc(100% - 130px);
        }
        .col-left {
            flex: 1;
            transition: all 0.5s ease-in-out;
            width: 100%;
            position: relative;
            padding: 10px 0 0 10px;
            box-sizing: border-box;
            &.with-sidebar {
                width: calc(100% - 380px);
            }

            .content-display {
                width: 100%;
                height: 100%;

                > div {
                    width: 100%;
                    height: 100%;
                }
            }
            // background-color: yellow;
            // padding:5px;
            .transition-overlay {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: rgba(0, 0, 0, 0.97);
                z-index: 1000;
                display: flex;
                justify-content: center;
                align-items: center;

                .loader {
                    border: 4px solid rgba(255, 255, 255, 0.3);
                    border-radius: 50%;
                    border-top: 4px solid #fff;
                    width: 40px;
                    height: 40px;
                    animation: spin 1s linear infinite;
                }

                @keyframes spin {
                    0% {
                        transform: rotate(0deg);
                    }
                    100% {
                        transform: rotate(360deg);
                    }
                }
            }
        }

        .col-right {
            background-color: rgb(20, 20, 20);
            flex-shrink: 0;
            transition: all 0.5s ease-in-out;
            // z-index: 20000;
            padding: 10px 10px 5px 0;
            box-sizing: border-box;
            @media only screen and (max-width: 768px) {
                padding-bottom: 60px;
            }
        }
    }

    .footer {
        height: auto;
        padding: 10px 20px;
        flex-shrink: 0;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        align-items: center;
        background-color: rgb(20, 20, 20);
        border-top: 1px solid #222;
        margin-top: 5px;
        width: 100%;
    }
`
